import { transform } from 'ol/proj';
import { GeoJSON } from 'ol/format';
export const isSameHighlight = (a, b) => {
    if (a.length === b.length) {
        return containHighlight(a, b);
    }
    return false;
};
export const containHighlight = (a, b) => {
    for (const newHighlightObj of a) {
        if (!b.some((currentHighlightObj) => currentHighlightObj.layerId === newHighlightObj.layerId &&
            currentHighlightObj.featureId === newHighlightObj.featureId)) {
            return false;
        }
    }
    return true;
};
export const fireHighlightInteraction = (map, feature) => {
    const geoJSONFormatter = new GeoJSON();
    const featureProjection = geoJSONFormatter.readProjection(feature).getCode();
    // Point, Line, Polygon,...
    const featureFirstCoordinate = geoJSONFormatter.readGeometry(feature.geometry).getFirstCoordinate();
    // fire map event pointermove over position -> set mapboxstyles in Interaction Highlight
    if (featureProjection && featureFirstCoordinate) {
        // check and convert coordinate projection
        const mapProjection = map.getView().getProjection().getCode();
        const isSameProjection = mapProjection === featureProjection;
        const coordinates = isSameProjection
            ? featureFirstCoordinate
            : transform(featureFirstCoordinate, featureProjection, mapProjection);
        const pixel = map.getPixelFromCoordinate(coordinates);
        map.dispatchEvent({
            type: 'pointermove',
            pixel,
            // how to get feature real ID without directly definition `_id ?? id`
            // to fix showing correct feature on crowded feature place
            data: { id: feature.properties?._id ?? feature.properties?.id },
        });
    }
};
//# sourceMappingURL=highlight.js.map